 import React, { useState } from "react";
import "./CompignEventSlider.css";
import { Link } from "react-router-dom";

import treeImg from "../assets/tree.jpg";
import plasticImg from "../assets/plastic.jpg";
import sutraImg from "../assets/sutra.jpg";
import waterDayImg from "../assets/water.jpg";
import earthDayImg from "../assets/earth.jpg";
import animalDayImg from "../assets/animal.jpg";

const cards = [
  {
    title: "Tree Plantation",
    img: treeImg,
    type: "Help us plant more trees for a greener and fresher environment",
    category: "campaign",
  },
  {
    title: "Avoid Plastic",
    img: plasticImg,
    type: "Say no to plastic bags and help us keep our city clean.",
    category: "campaign",
  },
  {
    title: "Safe Sutra Punjab",
    img: sutraImg,
    type: "Keep our streets clean and support a waste-free Punjab.",
    category: "campaign",
  },
  {
    title: "World Water Day",
    img: waterDayImg,
    type: "On March 22 Save every drop of water to ensure a better future for everyone.",
    category: "event",
  },
  {
    title: "Earth Day",
    img: earthDayImg,
    type: "On April 22 Lets protect our planet's beauty by taking small steps today.",
    category: "event",
  },
  {
    title: "Animal Day",
    img: animalDayImg,
    type: "On October 4 Join us in raising awareness to protect and care for all animals.",
    category: "event",
  },
];

function CampaignEventSlider() {
  const [index, setIndex] = useState(0);

  const CARD_WIDTH = 350;
  const GAP = 30;
  const VISIBLE_CARDS = 3;

  const nextSlide = () => {
    if (index < cards.length - VISIBLE_CARDS) {
      setIndex(index + 1);
    }
  };

  const prevSlide = () => {
    if (index > 0) {
      setIndex(index - 1);
    }
  };

  return (
    <div className="slider-section">
      <h2 className="slider-title">Campaigns & Events</h2>

      <div className="slider-wrapper">

        <button className="slider-arrow left" onClick={prevSlide}>
          ‹
        </button>

        <div className="slider-window">
          <div
            className="slider-track"
            style={{
              transform: `translateX(-${index * (CARD_WIDTH + GAP)}px)`,
            }}
          >
            {cards.map((item, i) => (
              <div className="slider-card" key={i}>

                <img src={item.img} alt={item.title} />

                <h3>{item.title}</h3>

                <p>{item.type}</p>

                {item.category === "campaign" ? (
                  <Link to="/campaign">
                    <button>View Details</button>
                  </Link>
                ) : (
                  <Link to="/event">
                    <button>View Details</button>
                  </Link>
                )}

              </div>
            ))}
          </div>
        </div>

        <button className="slider-arrow right" onClick={nextSlide}>
          ›
        </button>

      </div>
    </div>
  );
}

export default CampaignEventSlider;